import * as React from 'react';
import {NotionWrapper} from '@ux/notion-api';

const NotionTypography = () => (
	<NotionWrapper blockMap={{
	"blocks": [
		{
			"id": "9a57d34b-41d2-40e4-8c4d-132953b7a175",
			"type": "page",
			"properties": {
				"title": [
					[
						"Типографика"
					]
				]
			},
			"content": [
				"a0508eaa-e0fe-410c-bf75-f5a5e750df37",
				"417f2d0f-e6dd-43a7-bd2f-2749b6885b83",
				"2e02dd1d-730e-46d8-ad9e-badb5200d1cd",
				"eac3f88b-3670-4d8e-8999-b5038205f78c",
				"fdecf2a2-f9f5-4cff-9d1c-f559792b943e",
				"fec1feda-0112-4fef-b427-c7f214f6043f",
				"d0430774-e1f0-42cc-b73e-aa028cfeab84",
				"3c565e76-f056-4ec6-8c7e-262b88451e94",
				"27ed5101-55d6-42e2-835d-802b7f779df8",
				"fa733fcd-acdd-4aaa-8b6a-7746a0e9e556",
				"09c73de7-2743-4d47-9c4f-2d9af780f6d4",
				"84e122e5-c5fe-4bdc-b590-7700e9dee22b",
				"032d393f-039e-4e04-8ff3-9f770086071e",
				"869fb6e3-f43b-48ce-b150-43d9d1cd8ed0",
				"e598fcea-fc87-434b-9b53-e048c69c4acc",
				"75109796-daf1-47e2-83b8-aefee69b8728",
				"5ddcaa39-b53c-4459-8bd2-78820aa1056f",
				"acd962fa-e33a-42b4-b6c8-39e30db087f7",
				"955a3599-0da2-464a-86bc-4a3aacf9b8e2",
				"26d90b92-4344-4fa2-89f6-61e140c31082",
				"fd280097-0c9c-4ad2-a7a0-2493eaeef863",
				"beb742c2-266d-45b1-b793-030952830837",
				"d73c3b9c-b047-487c-8edb-965db47cd584",
				"8da4360e-50f5-4afd-ae08-23dffd3430e0",
				"345ce827-4d22-4f57-ab4a-df253fb1c12b",
				"65c3d72b-5e25-482b-9f13-2c1ba5d444e9",
				"3b7ba734-32fb-4db2-8aa5-8f997dd04b8f",
				"e612fac4-120c-412f-a640-7dd498d4417d",
				"0377cd57-faf3-4b46-ab2e-61832ae4c215",
				"f7bc973f-72db-462f-a6c6-59dd831e1f80",
				"af64d8fb-8a9e-420f-aac0-405361d1b3bb",
				"b5e0da7e-05eb-4ba2-820f-d039f7f49d55",
				"68ce40df-7568-4e69-a853-f5892642340d",
				"744e4729-474c-4ea6-802e-755cbe24b71e",
				"4d749360-467a-4346-a067-38867ef7f649"
			],
			"format": {
				"copied_from_pointer": {
					"id": "eb5aca2e-4051-43e0-985c-9a7ea7e7f081",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"parent_table": "block",
			"file_ids": [
				"6e2d5868-cae8-4bbe-9be4-c18b62c76f22"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a7f0ba9f-a91a-4924-8447-b93845e6da1c",
			"type": "page",
			"properties": {
				"title": [
					[
						"Paradigm"
					]
				]
			},
			"content": [
				"d4e0a1ac-e02e-4158-9d96-534ae9fa2c53",
				"b091b55a-a32c-4567-82d7-65c50636e3a7",
				"4e937b6d-4b2c-45c6-ab8c-e9dc9fa9bc2a",
				"7adbd680-541d-4e6e-97d1-f277bd1610c0",
				"ec15c567-4038-4c10-81bb-0a86aee56b08",
				"9a57d34b-41d2-40e4-8c4d-132953b7a175",
				"da552996-155b-442f-9ecf-0bdce521a35e",
				"1f51d543-236b-4b29-a278-4bed543f50b5",
				"5f304e57-18f8-4cd9-b80b-07951787740a",
				"f5097b73-1152-4e95-8919-54eed014af82",
				"94cd6ab9-c518-4094-829c-36d8a73e8010",
				"88cf99fd-dc9d-4649-8601-eb5198351e06",
				"d21336ae-ecfc-4130-a757-19109a89ad74",
				"e916c9a3-5983-4c34-bec3-187e417c593c",
				"cd7c41d2-ae59-4c69-b7d6-4254cf727ff5",
				"7ba8f4fe-6d71-4e1f-a1eb-1df9e3da0099",
				"31c9a6bd-328b-4869-aecd-fabd86f3cf15",
				"cb2b1b2c-b795-4abf-b11f-772b33e43908",
				"a47c1d35-578a-4679-8907-d8b13ab1bb65",
				"41e2749d-ddd3-4a06-b224-0ae6b4c9d436",
				"c3e7c6b7-650d-456d-8997-a4d049587d58",
				"7472c506-f9da-4f2e-85ba-59623551e747",
				"16b738c5-499f-42a0-baf4-cffb990a0b25",
				"51181f46-f9ad-4d25-b2c3-a59f7c7b8587",
				"e8ea6408-fc0d-4be8-8020-e982cc7c9b55",
				"3143e3ff-a6eb-4e48-8197-d96fceb48f9e",
				"20802187-e25a-4d38-af64-a363ffcace1d",
				"311c23ba-4ac6-48a0-bf3b-de8b115c363f",
				"aec03706-7113-42af-8724-4b446502d53a",
				"4836526c-ce6a-4bfd-8c2f-4bcb9a446e1e",
				"e0b8f319-a947-4c5d-8bdf-cd0ffeea5a6d",
				"aa0d9786-1b50-47f5-bc1f-9ec3e47ccd69",
				"98a66dbd-731e-498f-9c5f-7790d1f555e0",
				"c7ec9e06-de22-4861-88e6-e6d45e0de285",
				"55690b50-0664-4442-9ded-4645f2f318e9"
			],
			"parent_id": "1fcd74a2-648f-4dfc-a4d8-abbb9a7bfb29",
			"parent_table": "team",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a0508eaa-e0fe-410c-bf75-f5a5e750df37",
			"type": "code",
			"properties": {
				"title": [
					[
						"<meta type=\"url\" value=\"/typography\"/>"
					]
				],
				"language": [
					[
						"JavaScript"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "5ec5be76-efc5-432d-9606-c0f77b247c89",
					"table": "block",
					"spaceId": "22066aad-9295-4afc-88d1-dae5d26fea31"
				}
			},
			"parent_id": "9a57d34b-41d2-40e4-8c4d-132953b7a175",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "417f2d0f-e6dd-43a7-bd2f-2749b6885b83",
			"type": "text",
			"properties": {
				"title": [
					[
						"Типографика и фирменный шрифт помогают считывать смысл сообщения и делают бренд узнаваемым."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "6afb608c-29c0-4dc9-802a-0b492e0000aa",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "9a57d34b-41d2-40e4-8c4d-132953b7a175",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2e02dd1d-730e-46d8-ad9e-badb5200d1cd",
			"type": "image",
			"properties": {
				"size": [
					[
						"150.0KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/63e80f1d-5bab-4370-a4b4-113925538f99/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 1456,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/63e80f1d-5bab-4370-a4b4-113925538f99/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5494505494505495,
				"block_preserve_scale": true
			},
			"parent_id": "9a57d34b-41d2-40e4-8c4d-132953b7a175",
			"parent_table": "block",
			"file_ids": [
				"63e80f1d-5bab-4370-a4b4-113925538f99"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/2e02dd1d-730e-46d8-ad9e-badb5200d1cd.png"
		},
		{
			"id": "eac3f88b-3670-4d8e-8999-b5038205f78c",
			"type": "quote",
			"properties": {
				"title": [
					[
						"Убедитесь, что пользователю не нужно прилагать усилий для чтения текста на странице",
						[
							[
								"b"
							]
						]
					],
					[
						". В интерфейсах мы рекомендуем использовать шрифты без засечек, для контента и длинных документов — с засечками. "
					],
					[
						"Material Design о типографике",
						[
							[
								"a",
								"https://material.io/design/color/text-legibility.html#legibility-standards",
								true
							]
						]
					]
				]
			},
			"format": {
				"page_icon": "💡",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "10df2740-257a-4376-8b2d-1717257c23fe",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "9a57d34b-41d2-40e4-8c4d-132953b7a175",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fdecf2a2-f9f5-4cff-9d1c-f559792b943e",
			"type": "header",
			"properties": {
				"title": [
					[
						"VK Sans Display"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "578020d1-5f55-4ceb-b398-905dbdfd758d",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "9a57d34b-41d2-40e4-8c4d-132953b7a175",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fec1feda-0112-4fef-b427-c7f214f6043f",
			"type": "text",
			"properties": {
				"title": [
					[
						"VK Sans Display — фирменный шрифт и ключевой элемент брендинга наших продуктов. В интерфейсах мы рекомендуем использовать его в заголовках, промоэлементах и навигации."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "81939c7c-cb11-40d6-848d-0a8e3c4c312a",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "9a57d34b-41d2-40e4-8c4d-132953b7a175",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d0430774-e1f0-42cc-b73e-aa028cfeab84",
			"type": "image",
			"properties": {
				"size": [
					[
						"72.7KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/20aee097-4d66-4d15-b041-4d980b2b9389/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 1456,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/20aee097-4d66-4d15-b041-4d980b2b9389/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5,
				"block_preserve_scale": true
			},
			"parent_id": "9a57d34b-41d2-40e4-8c4d-132953b7a175",
			"parent_table": "block",
			"file_ids": [
				"20aee097-4d66-4d15-b041-4d980b2b9389"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/d0430774-e1f0-42cc-b73e-aa028cfeab84.png"
		},
		{
			"id": "3c565e76-f056-4ec6-8c7e-262b88451e94",
			"type": "header",
			"properties": {
				"title": [
					[
						"Системные шрифты"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "89a30763-4d25-44dc-9883-c3b15dd03750",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "9a57d34b-41d2-40e4-8c4d-132953b7a175",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "27ed5101-55d6-42e2-835d-802b7f779df8",
			"type": "column_list",
			"content": [
				"2661399a-cbd3-41c2-beba-0833ef421c9f",
				"7bcc287c-3546-4517-a84f-3b089e585c28"
			],
			"format": {
				"copied_from_pointer": {
					"id": "83834f9a-0a33-46ec-be27-1bde264c906e",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "9a57d34b-41d2-40e4-8c4d-132953b7a175",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fa733fcd-acdd-4aaa-8b6a-7746a0e9e556",
			"type": "column_list",
			"content": [
				"1adfbd85-d81b-433f-9e59-4f3b3c5c0e4a",
				"361a6494-efea-4963-adf3-04a80cddfb75"
			],
			"format": {
				"copied_from_pointer": {
					"id": "983312be-c6b3-42bd-8b98-709847002ce7",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "9a57d34b-41d2-40e4-8c4d-132953b7a175",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "09c73de7-2743-4d47-9c4f-2d9af780f6d4",
			"type": "header",
			"properties": {
				"title": [
					[
						"Шрифтовые пары"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "bf4a7512-a2a6-4238-bf0e-067875e98ba3",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "9a57d34b-41d2-40e4-8c4d-132953b7a175",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "84e122e5-c5fe-4bdc-b590-7700e9dee22b",
			"type": "text",
			"properties": {
				"title": [
					[
						"Мы рекомендуем использовать проверенные шрифтовые пары и сочетания на основе фирменного VK Sans Display."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "2c17d81d-5161-4ed8-8ca8-9dc7f5d4e4b5",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "9a57d34b-41d2-40e4-8c4d-132953b7a175",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "032d393f-039e-4e04-8ff3-9f770086071e",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"VK Sans Display + Inter"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "3856a361-241f-42d2-af84-8485fc10de9c",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "9a57d34b-41d2-40e4-8c4d-132953b7a175",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "869fb6e3-f43b-48ce-b150-43d9d1cd8ed0",
			"type": "text",
			"properties": {
				"title": [
					[
						"Заголовок — "
					],
					[
						"VK Sans Display",
						[
							[
								"b"
							]
						]
					],
					[
						" в начертании "
					],
					[
						"Medium",
						[
							[
								"b"
							]
						]
					],
					[
						" или "
					],
					[
						"Demibold",
						[
							[
								"b"
							]
						]
					],
					[
						". Наборный шрифт — "
					],
					[
						"Inter",
						[
							[
								"b"
							]
						]
					],
					[
						" в начертании "
					],
					[
						"Regular",
						[
							[
								"b"
							]
						]
					],
					[
						". Эта шрифтовая пара подходит для любой платформы."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "7f57b452-b898-4840-84be-741bae58f4b1",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "9a57d34b-41d2-40e4-8c4d-132953b7a175",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e598fcea-fc87-434b-9b53-e048c69c4acc",
			"type": "image",
			"properties": {
				"size": [
					[
						"60.6KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/fac40198-2aa9-49e7-b49f-988e2979bc1a/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 1456,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/fac40198-2aa9-49e7-b49f-988e2979bc1a/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.3090659340659341,
				"block_preserve_scale": true
			},
			"parent_id": "9a57d34b-41d2-40e4-8c4d-132953b7a175",
			"parent_table": "block",
			"file_ids": [
				"fac40198-2aa9-49e7-b49f-988e2979bc1a"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/e598fcea-fc87-434b-9b53-e048c69c4acc.png"
		},
		{
			"id": "75109796-daf1-47e2-83b8-aefee69b8728",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"VK Sans Display + Native Font"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "ceb4ce45-fcd4-44b8-b65c-fda5df8721cc",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "9a57d34b-41d2-40e4-8c4d-132953b7a175",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5ddcaa39-b53c-4459-8bd2-78820aa1056f",
			"type": "text",
			"properties": {
				"title": [
					[
						"Заголовок — "
					],
					[
						"VK Sans Display",
						[
							[
								"b"
							]
						]
					],
					[
						" в начертании "
					],
					[
						"Demibold",
						[
							[
								"b"
							]
						]
					],
					[
						". Наборный шрифт — системный: "
					],
					[
						"Arial",
						[
							[
								"b"
							]
						]
					],
					[
						" для Windows, "
					],
					[
						"Helvetica Neue",
						[
							[
								"b"
							]
						]
					],
					[
						" для Mac, "
					],
					[
						"San Francisco",
						[
							[
								"b"
							]
						]
					],
					[
						" для iOS, "
					],
					[
						"Roboto",
						[
							[
								"b"
							]
						]
					],
					[
						" для Android. В Android  рекомендуем использовать "
					],
					[
						"Inter",
						[
							[
								"b"
							]
						]
					],
					[
						"."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "c5f312e8-9ff4-401c-918e-bcdfb8545728",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "9a57d34b-41d2-40e4-8c4d-132953b7a175",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "acd962fa-e33a-42b4-b6c8-39e30db087f7",
			"type": "image",
			"properties": {
				"size": [
					[
						"61.9KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/13649754-647b-4b5a-801f-51dc51673dc2/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/13649754-647b-4b5a-801f-51dc51673dc2/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.2733516483516483,
				"block_preserve_scale": true
			},
			"parent_id": "9a57d34b-41d2-40e4-8c4d-132953b7a175",
			"parent_table": "block",
			"file_ids": [
				"13649754-647b-4b5a-801f-51dc51673dc2"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/acd962fa-e33a-42b4-b6c8-39e30db087f7.png"
		},
		{
			"id": "955a3599-0da2-464a-86bc-4a3aacf9b8e2",
			"type": "header",
			"properties": {
				"title": [
					[
						"Настройки типографики"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "58ec5f77-38fb-4acb-a319-ba8234b85791",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "9a57d34b-41d2-40e4-8c4d-132953b7a175",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "26d90b92-4344-4fa2-89f6-61e140c31082",
			"type": "text",
			"properties": {
				"title": [
					[
						"В зависимости от типа продукта мы используем разные подходы к типографике."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "f0e15ba7-e4f3-49f9-8c29-2d427239a837",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "9a57d34b-41d2-40e4-8c4d-132953b7a175",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fd280097-0c9c-4ad2-a7a0-2493eaeef863",
			"type": "quote",
			"properties": {
				"title": [
					[
						"Внимательно отнеситесь к высоте текста, оптимальной для чтения. ",
						[
							[
								"b"
							]
						]
					],
					[
						"Чем больше размер шрифта и толщина линий, тем больше должна быть высота строки. Строки, расположенные слишком плотно или слишком свободно, ухудшают читаемость текста, глазу сложнее найти новую строку. "
					],
					[
						"Material Design o типографике",
						[
							[
								"a",
								"https://material.io/design/color/text-legibility.html#legibility-standards",
								true
							]
						]
					]
				]
			},
			"format": {
				"page_icon": "💡",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "5287c294-8ce9-4e70-b07a-131142003b55",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "9a57d34b-41d2-40e4-8c4d-132953b7a175",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "beb742c2-266d-45b1-b793-030952830837",
			"type": "column_list",
			"content": [
				"cb682bd6-6e9d-41f6-b413-905839af22e4",
				"8792bd60-ae6c-4d89-b2f3-1c589f03b68b"
			],
			"format": {
				"copied_from_pointer": {
					"id": "d49919d7-4a39-4f1b-9272-71fbe3922594",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "9a57d34b-41d2-40e4-8c4d-132953b7a175",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "d73c3b9c-b047-487c-8edb-965db47cd584",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Выключка"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "ef276301-6d6b-49c1-900f-7f8edf26ed81",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "9a57d34b-41d2-40e4-8c4d-132953b7a175",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8da4360e-50f5-4afd-ae08-23dffd3430e0",
			"type": "text",
			"properties": {
				"title": [
					[
						"Рекомендуется использовать левую выключку для текста."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "10b590ed-60bc-4dd7-8da0-cd7f70b5d6bf",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "9a57d34b-41d2-40e4-8c4d-132953b7a175",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "345ce827-4d22-4f57-ab4a-df253fb1c12b",
			"type": "column_list",
			"content": [
				"0d3cdde6-6f99-424c-bc53-f603d1140f55",
				"2b57f963-a88c-4a3c-b2e4-896823abb339"
			],
			"format": {
				"copied_from_pointer": {
					"id": "a5ee01a6-063f-4df6-82ca-570b109c468f",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "9a57d34b-41d2-40e4-8c4d-132953b7a175",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "65c3d72b-5e25-482b-9f13-2c1ba5d444e9",
			"type": "text",
			"format": {
				"copied_from_pointer": {
					"id": "20be172c-7d82-46bd-a4a6-cbb988c3fa68",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "9a57d34b-41d2-40e4-8c4d-132953b7a175",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3b7ba734-32fb-4db2-8aa5-8f997dd04b8f",
			"type": "text",
			"properties": {
				"title": [
					[
						"Центральная выключка допустима для небольших объемов текста и заголовков."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b568233d-6bb9-4eb2-acfa-d594e750d971",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "9a57d34b-41d2-40e4-8c4d-132953b7a175",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e612fac4-120c-412f-a640-7dd498d4417d",
			"type": "column_list",
			"content": [
				"bdec8952-082b-4a40-8fc0-c87cc3f72a55",
				"014268c0-e952-4b8b-9cfe-7b7fa9f57ffd"
			],
			"format": {
				"copied_from_pointer": {
					"id": "ec3ecf0e-5d63-4d17-a1e7-94b6d0614fb6",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "9a57d34b-41d2-40e4-8c4d-132953b7a175",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0377cd57-faf3-4b46-ab2e-61832ae4c215",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Регистр"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "fbb34804-e2d9-42c6-86bc-8819f1a77616",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "9a57d34b-41d2-40e4-8c4d-132953b7a175",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "f7bc973f-72db-462f-a6c6-59dd831e1f80",
			"type": "text",
			"properties": {
				"title": [
					[
						"Мы рекомендуем избегать набора текста в верхнем регистре и использовать его только для компонентов типа тегов."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "b734b920-6ffe-4d4c-93c6-3b74d2dc351a",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "9a57d34b-41d2-40e4-8c4d-132953b7a175",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "af64d8fb-8a9e-420f-aac0-405361d1b3bb",
			"type": "column_list",
			"content": [
				"eb8bb157-396e-42e5-99b0-9b44894c108d",
				"14d0c85b-0304-4a42-a04d-2529b2a29f2f"
			],
			"format": {
				"copied_from_pointer": {
					"id": "ea4a7a93-1061-4728-bdbb-68cd3b83dedc",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "9a57d34b-41d2-40e4-8c4d-132953b7a175",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "b5e0da7e-05eb-4ba2-820f-d039f7f49d55",
			"type": "header",
			"properties": {
				"title": [
					[
						"Палитра"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "41ae5975-ce59-4b1a-bbcc-a6725911cd2e",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "9a57d34b-41d2-40e4-8c4d-132953b7a175",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "68ce40df-7568-4e69-a853-f5892642340d",
			"type": "text",
			"properties": {
				"title": [
					[
						"Для типографики мы рекомендуем использовать нашу палитру цветов. Токены для текста выделены в отдельную группу. У токенов семантические название, это поможет ориентироваться и правильно их применять. "
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "41085a9a-9322-424c-8b39-180d4b0e67a0",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "9a57d34b-41d2-40e4-8c4d-132953b7a175",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "744e4729-474c-4ea6-802e-755cbe24b71e",
			"type": "image",
			"properties": {
				"size": [
					[
						"114.6KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/a237e2b1-adb2-429d-afe2-8ad480218b9c/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 708,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/a237e2b1-adb2-429d-afe2-8ad480218b9c/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.8021978021978022,
				"block_preserve_scale": true
			},
			"parent_id": "9a57d34b-41d2-40e4-8c4d-132953b7a175",
			"parent_table": "block",
			"file_ids": [
				"a237e2b1-adb2-429d-afe2-8ad480218b9c"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/744e4729-474c-4ea6-802e-755cbe24b71e.png"
		},
		{
			"id": "4d749360-467a-4346-a067-38867ef7f649",
			"type": "text",
			"parent_id": "9a57d34b-41d2-40e4-8c4d-132953b7a175",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2661399a-cbd3-41c2-beba-0833ef421c9f",
			"type": "column",
			"content": [
				"9c7fa750-7d0e-40fd-83ae-ef2292e3f127",
				"2965c14d-fbc8-4bb9-8f18-5807a0589311",
				"842dee73-58c0-4b4e-a61e-dbbb28eb0bf1"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "50a29fc9-96e8-4ea5-ad65-0cab7db00735",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "27ed5101-55d6-42e2-835d-802b7f779df8",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "7bcc287c-3546-4517-a84f-3b089e585c28",
			"type": "column",
			"content": [
				"a2868ea2-79ee-4343-bde5-334dd6b3fc95",
				"ba1d7ee1-f598-47ea-bad3-91dfaf0265a3",
				"528d7b4c-9eda-444d-9769-899db7635a5f"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "56c5f642-39e5-47f7-9008-b5bfc8478f07",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "27ed5101-55d6-42e2-835d-802b7f779df8",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "9c7fa750-7d0e-40fd-83ae-ef2292e3f127",
			"type": "image",
			"properties": {
				"size": [
					[
						"30.5KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/c1fd89c6-6a41-4174-991d-d687d017b538/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"block_height": 364,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/c1fd89c6-6a41-4174-991d-d687d017b538/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5290697674418605,
				"block_preserve_scale": true
			},
			"parent_id": "2661399a-cbd3-41c2-beba-0833ef421c9f",
			"parent_table": "block",
			"file_ids": [
				"c1fd89c6-6a41-4174-991d-d687d017b538"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/9c7fa750-7d0e-40fd-83ae-ef2292e3f127.png"
		},
		{
			"id": "2965c14d-fbc8-4bb9-8f18-5807a0589311",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Helvetica Neue"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "95439a0b-c19e-41b9-9746-9160cbbec212",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "2661399a-cbd3-41c2-beba-0833ef421c9f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "842dee73-58c0-4b4e-a61e-dbbb28eb0bf1",
			"type": "text",
			"properties": {
				"title": [
					[
						"Для macOS"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "fac1fdff-dc06-4a8d-ac7f-c9776fdcb61d",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "2661399a-cbd3-41c2-beba-0833ef421c9f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "a2868ea2-79ee-4343-bde5-334dd6b3fc95",
			"type": "image",
			"properties": {
				"size": [
					[
						"32.1KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/435ce1f8-d187-47f7-b528-d3267c5acc4c/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"block_height": 364,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/435ce1f8-d187-47f7-b528-d3267c5acc4c/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5290697674418605,
				"block_preserve_scale": true
			},
			"parent_id": "7bcc287c-3546-4517-a84f-3b089e585c28",
			"parent_table": "block",
			"file_ids": [
				"435ce1f8-d187-47f7-b528-d3267c5acc4c"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/a2868ea2-79ee-4343-bde5-334dd6b3fc95.png"
		},
		{
			"id": "ba1d7ee1-f598-47ea-bad3-91dfaf0265a3",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Arial"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "6ee58460-eeac-4e36-8a82-a42d567dbd3d",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7bcc287c-3546-4517-a84f-3b089e585c28",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "528d7b4c-9eda-444d-9769-899db7635a5f",
			"type": "text",
			"properties": {
				"title": [
					[
						"Для Windows"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "1eeb5116-0295-46e5-838c-b853dbd98663",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "7bcc287c-3546-4517-a84f-3b089e585c28",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "1adfbd85-d81b-433f-9e59-4f3b3c5c0e4a",
			"type": "column",
			"content": [
				"fb2319e3-4243-4e3f-9dd6-e977c55d8df6",
				"dc15ae51-1499-41b6-b42f-d5c7ec35490b",
				"eb434589-69e2-4789-8500-ad57d011cc5b",
				"6e06692a-541d-4ecd-8727-bfed562025ea"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "06183ae5-d161-4d00-ac10-3c3fbc396192",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "fa733fcd-acdd-4aaa-8b6a-7746a0e9e556",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "361a6494-efea-4963-adf3-04a80cddfb75",
			"type": "column",
			"content": [
				"af309447-cc80-4bb5-acb2-d9118917e65f",
				"3d10ef53-c758-4a64-a6e7-39254e66ea69",
				"c44a9d2c-e60b-4757-affb-f82a704d051c",
				"57379ae5-0f49-4b82-8caa-0ed8634071ac"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "d3a454fc-765a-4994-832c-ebce53efdf69",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "fa733fcd-acdd-4aaa-8b6a-7746a0e9e556",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "fb2319e3-4243-4e3f-9dd6-e977c55d8df6",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"San Francisco"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "0b8f51f7-6c97-494e-94ff-bbc178ff3ea2",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1adfbd85-d81b-433f-9e59-4f3b3c5c0e4a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "dc15ae51-1499-41b6-b42f-d5c7ec35490b",
			"type": "image",
			"properties": {
				"size": [
					[
						"30.4KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/45f70d01-dffc-4f9d-9497-4518ac8d9f59/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"block_height": 364,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/45f70d01-dffc-4f9d-9497-4518ac8d9f59/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5290697674418605,
				"block_preserve_scale": true
			},
			"parent_id": "1adfbd85-d81b-433f-9e59-4f3b3c5c0e4a",
			"parent_table": "block",
			"file_ids": [
				"45f70d01-dffc-4f9d-9497-4518ac8d9f59"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/dc15ae51-1499-41b6-b42f-d5c7ec35490b.png"
		},
		{
			"id": "eb434589-69e2-4789-8500-ad57d011cc5b",
			"type": "text",
			"properties": {
				"title": [
					[
						"Наборный шрифт в iOS"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "40aacd01-369e-4b25-81d9-7dd8c8ee7005",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1adfbd85-d81b-433f-9e59-4f3b3c5c0e4a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6e06692a-541d-4ecd-8727-bfed562025ea",
			"type": "bookmark",
			"properties": {
				"link": [
					[
						"https://developer.apple.com/fonts/"
					]
				],
				"title": [
					[
						"Fonts - Apple Developer"
					]
				],
				"caption": [
					[
						"Скачать"
					]
				],
				"description": [
					[
						"Get the details, frameworks, and tools you need to use system fonts for Apple platforms in your apps. These typefaces offer the control and flexibility to optimally display text at a variety of sizes, in many different languages, across multiple interfaces."
					]
				]
			},
			"format": {
				"bookmark_icon": "https://developer.apple.com/favicon.ico?51002006191",
				"bookmark_cover": "https://developer.apple.com/news/images/og/fonts-og.jpg",
				"copied_from_pointer": {
					"id": "a7104345-2fde-4144-9cc0-a5162fe4ebc2",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "1adfbd85-d81b-433f-9e59-4f3b3c5c0e4a",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "af309447-cc80-4bb5-acb2-d9118917e65f",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Inter"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "6c038260-b977-4a10-a175-4af1ec42ca8e",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "361a6494-efea-4963-adf3-04a80cddfb75",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3d10ef53-c758-4a64-a6e7-39254e66ea69",
			"type": "image",
			"properties": {
				"size": [
					[
						"28.2KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/b6938211-83b1-43a5-9603-348377a1d20f/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 384,
				"block_height": 364,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/b6938211-83b1-43a5-9603-348377a1d20f/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5290697674418605,
				"block_preserve_scale": true
			},
			"parent_id": "361a6494-efea-4963-adf3-04a80cddfb75",
			"parent_table": "block",
			"file_ids": [
				"b6938211-83b1-43a5-9603-348377a1d20f"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/3d10ef53-c758-4a64-a6e7-39254e66ea69.png"
		},
		{
			"id": "c44a9d2c-e60b-4757-affb-f82a704d051c",
			"type": "text",
			"properties": {
				"title": [
					[
						"Наборный шрифт в Android"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "912f40d8-915f-4daa-9e93-9855f41bfe8c",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "361a6494-efea-4963-adf3-04a80cddfb75",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "57379ae5-0f49-4b82-8caa-0ed8634071ac",
			"type": "bookmark",
			"properties": {
				"link": [
					[
						"https://fonts.google.com/specimen/Inter?query=inter"
					]
				],
				"title": [
					[
						"Google Fonts"
					]
				],
				"caption": [
					[
						"Скачать"
					]
				],
				"description": [
					[
						"Making the web more beautiful, fast, and open through great typography"
					]
				]
			},
			"format": {
				"bookmark_icon": "https://www.gstatic.com/images/branding/product/ico/google_fonts_blue_lodp.ico",
				"bookmark_cover": "https://www.gstatic.com/images/icons/material/apps/fonts/1x/opengraph_color_blue_1200dp.png",
				"copied_from_pointer": {
					"id": "0e0b3b98-47ea-4ab8-b682-dc0fea6fa216",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "361a6494-efea-4963-adf3-04a80cddfb75",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "cb682bd6-6e9d-41f6-b413-905839af22e4",
			"type": "column",
			"content": [
				"db71150b-cd59-4e48-a842-1baec52af4ce",
				"3e3a875b-51f4-46cd-be21-395b055dc2fa"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "bccf76a8-6a99-4458-a4b6-f937d2a5890e",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "beb742c2-266d-45b1-b793-030952830837",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "8792bd60-ae6c-4d89-b2f3-1c589f03b68b",
			"type": "column",
			"content": [
				"e3853ec7-fba5-42aa-ae78-2cbf7b39fe4c",
				"0af23eb2-fea7-4201-bf39-e324f2d5c040"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "5d0f3e89-c649-4234-8111-d3589bd85bf7",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "beb742c2-266d-45b1-b793-030952830837",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "db71150b-cd59-4e48-a842-1baec52af4ce",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Сервисы"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "a150d081-6dab-4832-bfea-ec3f666ef6de",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "cb682bd6-6e9d-41f6-b413-905839af22e4",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "3e3a875b-51f4-46cd-be21-395b055dc2fa",
			"type": "text",
			"properties": {
				"title": [
					[
						"Для продуктов с высокой функциональной нагрузкой мы используем более компактную типографику."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "19e33c0c-71d6-44a0-a43f-feaedd4f9dbc",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "cb682bd6-6e9d-41f6-b413-905839af22e4",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e3853ec7-fba5-42aa-ae78-2cbf7b39fe4c",
			"type": "sub_sub_header",
			"properties": {
				"title": [
					[
						"Медиа"
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "f4d54d8c-e08f-46bd-9f9e-86e4416fd692",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "8792bd60-ae6c-4d89-b2f3-1c589f03b68b",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0af23eb2-fea7-4201-bf39-e324f2d5c040",
			"type": "text",
			"properties": {
				"title": [
					[
						"Для медиа, где важна читабельность контента, мы более сводобны в настройках типографики."
					]
				]
			},
			"format": {
				"copied_from_pointer": {
					"id": "33f15625-36b3-45d1-8d50-a4b99fdae658",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "8792bd60-ae6c-4d89-b2f3-1c589f03b68b",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "0d3cdde6-6f99-424c-bc53-f603d1140f55",
			"type": "column",
			"content": [
				"c36604e2-c288-4d31-8b4a-6d821e573345",
				"f73f8b7d-fa84-43b3-a688-3e316d33763f"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "e9e5b7dd-94aa-4322-96ec-401664962e43",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "345ce827-4d22-4f57-ab4a-df253fb1c12b",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "2b57f963-a88c-4a3c-b2e4-896823abb339",
			"type": "column",
			"content": [
				"5e0b15c6-9dcd-4545-af94-65baa789989d",
				"5b0157d7-253a-491d-b816-d97a2efd465a"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "ac178cde-a4e4-40ff-913e-156307e3e1dd",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "345ce827-4d22-4f57-ab4a-df253fb1c12b",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "c36604e2-c288-4d31-8b4a-6d821e573345",
			"type": "image",
			"properties": {
				"size": [
					[
						"21.5KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/0ea0c70c-6312-4ba5-9853-714cbba3fa7f/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"block_height": 364,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/0ea0c70c-6312-4ba5-9853-714cbba3fa7f/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5290697674418605,
				"block_preserve_scale": true
			},
			"parent_id": "0d3cdde6-6f99-424c-bc53-f603d1140f55",
			"parent_table": "block",
			"file_ids": [
				"0ea0c70c-6312-4ba5-9853-714cbba3fa7f"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/c36604e2-c288-4d31-8b4a-6d821e573345.png"
		},
		{
			"id": "f73f8b7d-fa84-43b3-a688-3e316d33763f",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Левая выключка лучше всего подходит для чтения текста"
					]
				]
			},
			"format": {
				"page_icon": "👍",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "463f2420-bd59-40e1-a88a-03b289e27c41",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "0d3cdde6-6f99-424c-bc53-f603d1140f55",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "5e0b15c6-9dcd-4545-af94-65baa789989d",
			"type": "image",
			"properties": {
				"size": [
					[
						"22.0KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/9781aaae-b31c-405b-bfc6-9695bcf2e259/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"block_height": 364,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/9781aaae-b31c-405b-bfc6-9695bcf2e259/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5290697674418605,
				"block_preserve_scale": true
			},
			"parent_id": "2b57f963-a88c-4a3c-b2e4-896823abb339",
			"parent_table": "block",
			"file_ids": [
				"9781aaae-b31c-405b-bfc6-9695bcf2e259"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/5e0b15c6-9dcd-4545-af94-65baa789989d.png"
		},
		{
			"id": "5b0157d7-253a-491d-b816-d97a2efd465a",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Правая выключка плохо подходит для чтения текста"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "1d739e1b-064d-48c4-9a44-bd5fb5cacb98",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "2b57f963-a88c-4a3c-b2e4-896823abb339",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "bdec8952-082b-4a40-8fc0-c87cc3f72a55",
			"type": "column",
			"content": [
				"cac7f364-7839-4c41-bade-03dcece367a8",
				"3193b48a-d8cb-4aac-95ab-bdd71892db55"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "f34c23a7-b963-4e8e-931a-0978cfc2a916",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "e612fac4-120c-412f-a640-7dd498d4417d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "014268c0-e952-4b8b-9cfe-7b7fa9f57ffd",
			"type": "column",
			"content": [
				"e85bd76a-1f79-4b16-a414-cd60e9dd58eb",
				"8978b072-da31-4021-9069-ca55e5775a06"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "63131e72-6a05-40e3-a997-99e682596e51",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "e612fac4-120c-412f-a640-7dd498d4417d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "cac7f364-7839-4c41-bade-03dcece367a8",
			"type": "image",
			"properties": {
				"size": [
					[
						"22.3KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/1389428d-0096-4153-9a4e-99f2aad641f6/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"block_height": 364,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/1389428d-0096-4153-9a4e-99f2aad641f6/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5290697674418605,
				"block_preserve_scale": true
			},
			"parent_id": "bdec8952-082b-4a40-8fc0-c87cc3f72a55",
			"parent_table": "block",
			"file_ids": [
				"1389428d-0096-4153-9a4e-99f2aad641f6"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/cac7f364-7839-4c41-bade-03dcece367a8.png"
		},
		{
			"id": "3193b48a-d8cb-4aac-95ab-bdd71892db55",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Допустимо для небольших объемов текста и заголовков"
					]
				]
			},
			"format": {
				"page_icon": "👌",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "f854715e-142f-4947-bf57-80a831f9baa9",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "bdec8952-082b-4a40-8fc0-c87cc3f72a55",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "e85bd76a-1f79-4b16-a414-cd60e9dd58eb",
			"type": "image",
			"properties": {
				"size": [
					[
						"22.6KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/148971db-d193-430d-86a8-b39b9e305648/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 384,
				"block_height": 364,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/148971db-d193-430d-86a8-b39b9e305648/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5290697674418605,
				"block_preserve_scale": true
			},
			"parent_id": "014268c0-e952-4b8b-9cfe-7b7fa9f57ffd",
			"parent_table": "block",
			"file_ids": [
				"148971db-d193-430d-86a8-b39b9e305648"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/e85bd76a-1f79-4b16-a414-cd60e9dd58eb.png"
		},
		{
			"id": "8978b072-da31-4021-9069-ca55e5775a06",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Выключка по ширине усложняет  чтение текста"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "46fb1bf6-af2d-43bd-9c75-6a4a912c370d",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "014268c0-e952-4b8b-9cfe-7b7fa9f57ffd",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "eb8bb157-396e-42e5-99b0-9b44894c108d",
			"type": "column",
			"content": [
				"4a656685-7a00-4fdf-bf28-6ebaba6cc0dc",
				"e9879af3-5187-4a5f-b122-6fc6756bf107"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "ffb270f2-b912-47c3-bd27-f30946dad746",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "af64d8fb-8a9e-420f-aac0-405361d1b3bb",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "14d0c85b-0304-4a42-a04d-2529b2a29f2f",
			"type": "column",
			"content": [
				"6e3584ca-ad9d-4513-b3e1-a04228ebc2cc",
				"f634f3cd-fbac-4e27-9543-d6e72a5c8760"
			],
			"format": {
				"column_ratio": 0.5,
				"copied_from_pointer": {
					"id": "8d4d7c3f-ab16-45af-859d-cac73ed7f020",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "af64d8fb-8a9e-420f-aac0-405361d1b3bb",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "4a656685-7a00-4fdf-bf28-6ebaba6cc0dc",
			"type": "image",
			"properties": {
				"size": [
					[
						"13.8KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/98e10b06-498a-4986-baa4-838e18226ee5/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 336,
				"block_height": 364,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/98e10b06-498a-4986-baa4-838e18226ee5/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5290697674418605,
				"block_preserve_scale": true
			},
			"parent_id": "eb8bb157-396e-42e5-99b0-9b44894c108d",
			"parent_table": "block",
			"file_ids": [
				"98e10b06-498a-4986-baa4-838e18226ee5"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/4a656685-7a00-4fdf-bf28-6ebaba6cc0dc.png"
		},
		{
			"id": "e9879af3-5187-4a5f-b122-6fc6756bf107",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Капс не мешает читаемости интерфейса в маленьком формате"
					]
				]
			},
			"format": {
				"page_icon": "👌",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "ec110ec0-541b-4f45-8a04-aa523915ad77",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "eb8bb157-396e-42e5-99b0-9b44894c108d",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		},
		{
			"id": "6e3584ca-ad9d-4513-b3e1-a04228ebc2cc",
			"type": "image",
			"properties": {
				"size": [
					[
						"13.2KB"
					]
				],
				"title": [
					[
						"Untitled"
					]
				],
				"source": [
					[
						"https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/b8ce9290-74d0-48a6-abc4-792c0b643843/Untitled.png"
					]
				]
			},
			"format": {
				"block_width": 384,
				"block_height": 364,
				"display_source": "https://prod-files-secure.s3.us-west-2.amazonaws.com/22066aad-9295-4afc-88d1-dae5d26fea31/b8ce9290-74d0-48a6-abc4-792c0b643843/Untitled.png",
				"block_full_width": false,
				"block_page_width": true,
				"block_aspect_ratio": 0.5290697674418605,
				"block_preserve_scale": true
			},
			"parent_id": "14d0c85b-0304-4a42-a04d-2529b2a29f2f",
			"parent_table": "block",
			"file_ids": [
				"b8ce9290-74d0-48a6-abc4-792c0b643843"
			],
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31",
			"path": "/notionStatic/6e3584ca-ad9d-4513-b3e1-a04228ebc2cc.png"
		},
		{
			"id": "f634f3cd-fbac-4e27-9543-d6e72a5c8760",
			"type": "callout",
			"properties": {
				"title": [
					[
						"Не рекомендуется использовать капс в заголовках"
					]
				]
			},
			"format": {
				"page_icon": "🚫",
				"block_color": "gray_background",
				"copied_from_pointer": {
					"id": "03a6210e-0741-4e7a-b4cb-a22fa4ffc278",
					"table": "block",
					"spaceId": "21a3776f-e138-48b4-802c-dfd96ab19cf3"
				}
			},
			"parent_id": "14d0c85b-0304-4a42-a04d-2529b2a29f2f",
			"parent_table": "block",
			"space_id": "22066aad-9295-4afc-88d1-dae5d26fea31"
		}
	],
	"headers": [
		{
			"title": "VK Sans Display",
			"id": "fdecf2a2-f9f5-4cff-9d1c-f559792b943e"
		},
		{
			"title": "Системные шрифты",
			"id": "3c565e76-f056-4ec6-8c7e-262b88451e94"
		},
		{
			"title": "Шрифтовые пары",
			"id": "09c73de7-2743-4d47-9c4f-2d9af780f6d4"
		},
		{
			"title": "Настройки типографики",
			"id": "955a3599-0da2-464a-86bc-4a3aacf9b8e2"
		},
		{
			"title": "Палитра",
			"id": "b5e0da7e-05eb-4ba2-820f-d039f7f49d55"
		}
	]
}} />
);

export default NotionTypography;
